module.exports = __webpack_public_path__ + "static/media/upgradeIllustration.87037ca9.svg";